import { GenericObject } from '~/prix/types/type'
import { ZodSchemaInfo } from '~/prix/types/zodType'

export type FilterableByShape = Record<string, ZodSchemaInfo>

export type FilterPropertyOption = {
  value: GenericObject & {
    key: string
    type?: string
    subType?: string
    keysAndLabels?: Record<string, string>
  }
  label: string
}

export function getFilterFieldLabel(key: string, field?: ZodSchemaInfo) {
  if (key === 'agentCpf') return 'Agente'
  return field?.label || key
}

export function getFilterFieldKeysAndLabels(field?: ZodSchemaInfo) {
  const keysAndLabels = field?.meta?.keysAndLabels
  if (!keysAndLabels || typeof keysAndLabels !== 'object' || Array.isArray(keysAndLabels)) {
    return undefined
  }

  const entries = Object.entries(keysAndLabels).filter(
    (entry): entry is [string, string] => typeof entry[1] === 'string',
  )

  return entries.length > 0 ? Object.fromEntries(entries) : undefined
}

export function buildFilterPropertyOptions(
  shape: FilterableByShape | undefined,
): FilterPropertyOption[] {
  if (!shape) return []

  return Object.keys(shape).map(key => {
    const field = shape[key]
    const keysAndLabels = getFilterFieldKeysAndLabels(field)
    const value: FilterPropertyOption['value'] = {
      key,
      ...(field?.type ? { type: field.type } : {}),
      ...(keysAndLabels
        ? {
            subType: 'enumerated',
            keysAndLabels,
          }
        : {}),
    }

    return {
      value,
      label: getFilterFieldLabel(key, field),
    }
  })
}
